import { Injectable } from "@angular/core"
import { BehaviorSubject } from "rxjs"
import { BusinessBanking } from "../meta/BusinessBanking.interface"
import { INITIAL_BUSINESS_BANKING } from "../meta/initial-business-banking.const"

@Injectable({
  providedIn: "root"
})
export class BusinessBankingService {
  private readonly _businessBanking$ = new BehaviorSubject<BusinessBanking>(INITIAL_BUSINESS_BANKING)
  public readonly businessBanking$ = this._businessBanking$.asObservable()

  public getBusinessBanking(): BusinessBanking {
    return this._businessBanking$.getValue()
  }

  public setBusinessBanking(businessBanking: Partial<BusinessBanking>): void {
    this._businessBanking$.next({
      ...this._businessBanking$.getValue(),
      ...businessBanking
    })
  }

}
